export default __webpack_public_path__ + "static/media/password-manager-3.1ee923a4.png";